export default __webpack_public_path__ + "static/media/crypto-app.bcd0b222.png";